import 'styles/index.less';
import 'uikitcss';

import $ from 'components/jquery';
import Form from 'helpers/form';
import Toast from 'components/toast';
import Loading from 'components/loading';
import UIkit from "uikit";
import Icons from "uikiticonsjs";
import Mask from 'helpers/mask';

UIkit.use(Icons);

interface ILoginModel {
    url: {
        index: string;
        enviarRedefinicaoSenha: string;
        postRedefinirSenha: string;
    },
    message: {
        error: string;
        success: string;
    }
}

let model: ILoginModel;

export function init(params: ILoginModel) {
    model = params;
    handlerMessage(model);
}

function handlerMessage(model: ILoginModel) {

    if (model.message.error)
        Toast.error(model.message.error);

    if (model.message.success)
        Toast.success(model.message.success);
}

export function postRedefinirSenha(form: HTMLFormElement) {
    let modelData = Form.serializeObject($(form))
    if (!modelData.isValid) return;
    $.post(model.url.postRedefinirSenha, modelData).done(() => {
        location.href = model.url.index;
    }).fail(message => {
            Toast.error(message);
        });
}

export function enviarRedefinicaoSenha(form: HTMLFormElement) {
    let modelData = Form.serializeObject($(form))
    if (!modelData.isValid) return;

    $(form).find('input, button, a').prop('disabled', true);

    $.post(model.url.enviarRedefinicaoSenha, modelData)
        .done((message) => {
            $(form).find('input, button, a').prop('disabled', false);
            Toast.success(message);
        })
        .fail(message => {
            Loading.hide();
            $(form).find('input, button, a').prop('disabled', false);
            Toast.error(message);
        });
}

export function isValid(form: HTMLFormElement) {
    let modelData = Form.serializeObject($(form));
    if (!modelData.isValid) return false;
    
    $(form).find('input, button, a').css('pointer-events', 'none');

    let spinner = $('<div class="spinner"></div>');
    $(form).find('button[type="submit"]').css('position', 'relative').append(spinner);
    $(form).find('button[type="submit"]').prop('disabled', true);
    Loading.hide();
    
    return true;
}

export function esqueceuSuaSenha() {
    $('#form-redefinir-senha').get(0).onreset = () => {};    
    $('#form-login').fadeOut(280, function () {
        $(this).addClass('uk-hidden');
        $('#form-redefinir-senha').removeClass('uk-hidden').fadeIn(280, function () {
            $('#form-redefinir-senha').find('[name="email"]').focus();
        });
    });
}

export function voltar() {
    $('#form-redefinir-senha').fadeOut(280, function () {
        $(this).addClass('uk-hidden');
        $('#form-login').removeClass('uk-hidden').fadeIn(280, function () {
            $('#form-login').find('[name="email"]').focus();
        });
    });
}

$(function () {
    $('#form-redefinir-senha[data-view="login"] button[type="submit"]').on('click', function () {
        $(this).text('Reenviar Instruções');
    });
    
    Mask.prevenirEspacosBrancos(['#form-login [name="email"]', '#form-login [name="password"]', '#form-redefinir-senha [name="email"]']);
});
